export const siteSettings = {
  name: "Capitalfinex",
  link: "https://capitalfinexpro.net",
  email: "support@capitalfinexpro.net",
  appLink: "https://app.capitalfinexpro.net",
};
